// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.region.handler.RentalGrowthRegionAutocompleteWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AutocompleteRegionRequestDto, AutocompleteRegionResponseDto } from '../..';

export const RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Path = '/api/web/v1/region/autocomplete';

export const RentalGrowthRegionAutocompleteWebApiHandler_autocomplete = (
  postData: AutocompleteRegionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AutocompleteRegionRequestDto, AutocompleteRegionResponseDto>(
    {
      endpoint: RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Path,
      method: 'POST',
      contextPath: '/rental-growth-api',
      postData: postData,
    },
    client,
  );
};
